export const enum StyleGroupSettingType {
  Color = 'color',
  Font = 'font',
  Weight = 'weight',
  Radius = 'radius',
  Group = 'group',
}
